import { useNavigate } from 'react-router';
export { pricingHandle as handle } from '../routeMetadata';
import { Button } from '../components/Button';
import { TAN_BG } from '../data/constants';
import { useProducts } from '../contexts/ProductContext';

export default function Pricing() {
  const navigate = useNavigate();
  const { products } = useProducts();

  // Find the lowest bidet installation price dynamically.
  // Catalog-rebuild-v2: legacy category='bidet installation' is now
  // product_type='installation_service'. Display key 'Category' on the mapped
  // Product object holds the product_type enum value.
  const installProducts = products.filter(
    (p) => p.Category === 'installation_service'
  );
  // If variations exist, use the lowest price from variations, else fallback to 0
  const installPrices = installProducts.map((p) => {
    if (p.variations && p.variations.length > 0) {
      return Math.min(...p.variations.map(v => v.msrp || 0));
    }
    return 0;
  });
  const minInstallPrice = (() => {
    const valid = installPrices.filter(p => p > 0);
    if (valid.length === 0) return 0;
    return Math.min(...valid);
  })();

  if (products.length === 0) {
    return <main className="min-h-screen" style={{ backgroundColor: TAN_BG }} />;
  }

  return (
    <main className="min-h-screen pb-8" style={{ backgroundColor: TAN_BG }}>
      <div className="container mx-auto px-4 pt-12">
        <h1 className="text-4xl font-bold mb-10 text-center">Transparent Pricing</h1>
        <p className="text-lg mb-12 text-center max-w-2xl mx-auto">
          <b>
            Bidet installation starts at
            <span className="text-blue-700">{' $'}{minInstallPrice.toFixed(2)}</span>
            {' '}+ tax, and installation pricing depends on the particular bidet you select.
          </b>
          <br /><br />
          Choose any bidet you like—
          <b>
            models start at
            <span className="text-blue-700">{' '}$29.99</span>
          </b>
          {' '}
          and go up from there. We charge you exactly what popular resellers charge, with no markup.
        </p>
        <div className="bg-white rounded-xl shadow-lg p-8 mb-16 max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold mb-4 text-center">How It Works</h2>
          <ol className="list-decimal pl-6 space-y-3 text-lg">
            <li>
              <b>Pick your bidet:</b>
              {' '}
              Click below to see our recommended models and choose the one that's right for you.
            </li>
            <li>
              <b>Installation fee:</b>
              {' '}
              starts at ${minInstallPrice.toFixed(2)} + tax, and depends on the bidet you choose.
            </li>
            <li>
              <b>Pay what popular resellers charge:</b>
              {' '}
              We order your bidet for you at the current Reseller Price (plus tax). No markup, no surprises.
            </li>
            <li>
              <b>We handle the rest:</b>
              {' '}
              We deliver, install, and show you how to use your new bidet.
            </li>
          </ol>
        </div>
        <div className="flex flex-col items-center justify-center my-12">
          <Button
            cta
            className="text-xl px-10 py-6 mb-4"
            style={{ fontSize: '1.5rem', minWidth: 280 }}
            onClick={() => navigate('/bidets')}
          >
            See Recommended Bidets
          </Button>
          <p className="text-gray-700 text-center max-w-xl">
            We’ve handpicked the best bidets for New York homes—easy to use, reliable, and available at the best prices. Click above to compare features, see our favorites, and pick the perfect model for your bathroom.
          </p>
        </div>
      </div>
      <section className="max-w-3xl mx-auto mb-10 text-center">
        <p className="text-lg font-semibold">
          Still have questions? Email us at
          {' '}
          <a href="mailto:support@bidetny.com" className="text-blue-700 underline">support@bidetny.com</a>
        </p>
      </section>
    </main>
  );
}
